// extracted by mini-css-extract-plugin
export default {"list":"ListStyling_list__sUWm5"};